import React from 'react';

export const GermanArticleButtons = ({onSubmit, userInput, onInputChange, isSubmitted }) => {
  const handleSubmit = (answer) => {
    //answer.preventDefault();
    userInput = answer;
    console.log("Child component - button clicked with answer:", answer);
    console.log("Child component - button clicked with answer:", userInput);
    onSubmit(userInput);
  };

  return (
      <div id="multipleChoiceGrammarSection">
      <div className="d-flex justify-content-between">
        <button 
          className="btn btn-outline-info btn-block custom-end-button my-2 w-100 mc-grammar-answer-btn" 
          type="button" 
          data-grammar-answer="der"
          onClick={() => handleSubmit('der')}
          disabled={isSubmitted}
        >
          der
        </button>
        <button 
          className="btn btn-outline-info btn-block custom-end-button my-2 w-100 mc-grammar-answer-btn" 
          type="button" 
          data-grammar-answer="die"
          onClick={() => handleSubmit('die')}
          disabled={isSubmitted}
        >
          die
        </button>
        <button 
          className="btn btn-outline-info btn-block custom-end-button my-2 w-100 mc-grammar-answer-btn" 
          type="button" 
          data-grammar-answer="das"
          onClick={() => handleSubmit('das')}
          disabled={isSubmitted}
        >
          das
        </button>
      </div>
    </div>
  );
};

export const DutchArticleButtons = ({onSubmit, userInput, onInputChange, isSubmitted }) => {
  const handleSubmit = (answer) => {
    //answer.preventDefault();
    userInput = answer;
    console.log("Child component - button clicked with answer:", answer);
    console.log("Child component - button clicked with answer:", userInput);
    onSubmit(userInput);
  };

  return (
      <div id="multipleChoiceGrammarSection">
      <div className="d-flex justify-content-between">
        <button 
          className="btn btn-outline-info btn-block custom-end-button my-2 w-100 mc-grammar-answer-btn" 
          type="button" 
          data-grammar-answer="de"
          onClick={() => handleSubmit('de')}
          disabled={isSubmitted}
        >
          de
        </button>
        <button 
          className="btn btn-outline-info btn-block custom-end-button my-2 w-100 mc-grammar-answer-btn" 
          type="button" 
          data-grammar-answer="het"
          onClick={() => handleSubmit('het')}
          disabled={isSubmitted}
        >
          het
        </button>
        
      </div>
    </div>
  );
};

export const GrammarFillin = ({onSubmit, userInput, onInputChange, isSubmitted }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit();
  };

  return (
      <div id = "fillInGrammarSection">
        <form onSubmit={handleSubmit}>
          <div class="input-group mb-3">
                <input 
                type="text" 
                id = "answerField" 
                className="form-control" 
                placeholder="Type answer here" 
                aria-label="answer" 
                aria-describedby="basic-addon2"
                value={userInput}
                onChange={onInputChange}
                disabled={isSubmitted}
                ></input>
                <div class="input-group-append">
                  <button 
                    id="answerButton" 
                    className="btn btn-outline-secondary" 
                    type="submit" 
                    disabled={isSubmitted}
                    >Answer</button>
                </div>
          </div>
        </form>
      </div>
  );
};
